import './index.scss'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { googleLoginRequest } from '../../../../action/auth-actions'

class SignUpWithGoogle extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {}

  setGoogleSignUp() {
    const scriptGoogleTagId = 'sign-up-with-google-script-tag'
    let scriptGoogleTag = document.getElementById(scriptGoogleTagId)
    if (scriptGoogleTag) {
      scriptGoogleTag.parentNode.removeChild(scriptGoogleTag)
    }
    const script = document.createElement('script')
    script.id = scriptGoogleTagId
    // script.src = 'https://apis.google.com/js/platform.js?onload=id-sign-up-with-google'
    script.src = 'https://apis.google.com/js/platform.js?onload=init'
    script.async = true
    script.defer = true
    document.getElementsByTagName('body')[0].appendChild(script)
    scriptGoogleTag = document.getElementById(scriptGoogleTagId)

    scriptGoogleTag.onload = () => {
      this.googleInit()
    }
  }

  googleInit() {
    try {
      window.gapi.load('auth2', () => {
        const auth2 = this.retrienAuth2()
        if (!auth2) return
        auth2.then(
          () => { this.attachSignUp(auth2) },
          (err) => { console.warn('[Google Sign-In] init failed (origin not authorized):', err) }
        )
      })
    } catch (e) {
      console.warn('gapi.load failed:', e)
    }
  }

  retrienAuth2() {
    const CLIENT_ID = '346918811661-4g8tav9je5earr4ca5f37naisgi8drgm.apps.googleusercontent.com'
    try {
      return window.gapi.auth2.init({
        client_id: CLIENT_ID,
        cookiepolicy: 'single_host_origin'
      })
    } catch (e) {
      console.warn('gapi.auth2.init failed:', e)
      return null
    }
  }

  attachSignUp(auth2) {
    let element = document.getElementById('id-sign-up-with-google')
    auth2.attachClickHandler(
      element,
      {},
      googleUser => {
        const googleUserProfile = googleUser.getBasicProfile()
        const id_token = googleUser.getAuthResponse().id_token
        const authObject = {
          token: id_token,
          stateName: '',
          photoUrl: googleUserProfile.getImageUrl(),
          loginProviderId: 1,
          externalLoginId: '',
          email: googleUserProfile.getEmail(),
          password: '',
          deviceId: '',
          firstName: googleUserProfile.getName(),
          lastName: googleUserProfile.getFamilyName()
        }

        console.log('Sign Up as: ' + googleUser.getBasicProfile())

        // googleLoginRequest makes the only request (WEB-7114).
        this.props.googleLogin(authObject)
          .catch(err => console.log(err.response ? err.response.text : err))
      },
      error => {
        console.log(JSON.stringify(error, undefined, 2))
      }
    )
  }

  signOut() {
    let auth2 = window.gapi.auth2.getAuthInstance()
    auth2.signOut().then(function () {
      console.log('Google User signed out.')
    })
  }

  render() {
    return (
      <div>
        <div id="g-sign-in-wrapper">
          <div id="id-sign-up-with-google" className="sign-up-with-google bm-ripple">
            <span className="icon" />
            <span className="buttonText">Sign Up with Google</span>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  googleLogin: googleAuthObj => dispatch(googleLoginRequest(googleAuthObj))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpWithGoogle)
